import { getSelectedDistrict, getSelectedState } from 'app/imports/App.selectors'
import { cszUrl } from 'features/Env'
import { useMemo } from 'react'
import { useSelector } from 'react-redux'

export function useScoresLink(sportId?: string) {
  const selectedState = useSelector(getSelectedState)
  const selectedDistrict = useSelector(getSelectedDistrict)

  const scoresUrl = useMemo(() => {
    const queryParams = []

    if (selectedState) {
      queryParams.push(`selectedStateId=${selectedState?.id}`)
    }

    if (selectedDistrict) {
      queryParams.push(`selectedCountyId=${selectedDistrict?.id}`)
    }

    if (sportId) {
      queryParams.push(`selectedSportId=${sportId}`)
    }

    queryParams.push('force=true')

    return `${cszUrl}/scores/forum?${queryParams.join('&')}`
  }, [selectedDistrict, selectedState, sportId])

  return { scoresUrl }
}
